import Vue from 'vue' // 引入 vue
import axios from 'axios' // 引入 axios
import qs from 'qs'

import externalApp from '../data/externalApp';

// config
import appConfig from '../appConfig';

// platformApi
import timerManager from '../components/platformApi/timerManager';

// utils
import consoleHelper from './consoleHelper';
import browserHelper from './browserHelper';
import appHelper from './appHelper';
import storageManager from "@comp/platformApi/storageManager";

// 全局设置 请求 URL，改为从 appConfig 里面配置
if (process.env.NODE_ENV === 'production') {
    if (process.env.VUE_APP_MODE === 'prod') { // prod 正式环境
        //production 生产环境
        axios.defaults.baseURL = '//api.shixun365.com/shixun/';
    } else if (process.env.VUE_APP_MODE === 'test') { // test 测试环境
        //test 测试环境
        axios.defaults.baseURL = '//jee.shixun365.com/shixun/'; //路径
    }
} else if (process.env.NODE_ENV === 'development') { //dev 开发环境
    // development 开发环境
    axios.defaults.baseURL = '//jee.shixun365.com/shixun/';
    // axios.defaults.baseURL = "http://192.168.1.104:8080/shixun";
    // 本地用 Nginx 反向代理 /shixun-mobile-2020/api/shixun/ 为 https://jee.shixun365.com/shixun/
    // 登录后把 JSESSIONID 的 domain 改为 localhost 即可完成登录
    // axios.defaults.baseURL = '/shixun-mobile-2020/api/shixun/';
}

axios.defaults.baseURL = appConfig.apiBaseUrl;

// 添加拦截器 请求前检查 请求方法 避免 post 请求被浏览器 换成 options
axios.interceptors.request.use(
    config => {

        config.headers.common['lastReferer'] = location.href;

        let Authorization = window.app.getAuthorization();
        if (window.app && window.app.getDebugStatus()) {
            // alert('Authorization=' + Authorization);
        }
        Authorization ?
            config.headers.common.Authorization = Authorization :
            null;

        if (config.method === 'post' || config.method === 'put' || config.method === 'delete') {
            config.data = qs.stringify(config.data);
            config.headers.common['Content-Type'] = 'application/x-www-form-urlencoded';
        }
        return config
    },
    error => {
        console.log('request:', error)
        Promise.reject(error)
    }
)

// 添加响应拦截器
axios.interceptors.response.use(function (response) {

    // consoleHelper.logDebug('ajax complete.');
    // let statusCode      = response.status;
    let responseText    = response.data;
    // let statusText      = response.statusText;

    // 请求出错可能返回空数据
    //consoleHelper.logDebug('complete data', jqXHR.responseText);
    if (responseText == null || responseText === "") {
        consoleHelper.logError('status text is null.');
        return;
    }
    let data = response.data;

    // if (data.errorCode === 1)
    // {
    //     appHelper.showHint(data.msg);
    // }
    if (data.errorCode === 2) {  // 未登录或因为会话超时需要重新登录

        debugger;
        // data.data 是服务端判断的，如果服务端判断是微信，则 data.data 为登录网址
        // if (data.data || browserHelper.isWechat)
        if (browserHelper.isWechat)
        {
            consoleHelper.log('errorCode: 2, current browser is wechat.');
            appHelper.showHint('转到微信登录');

            timerManager.setTimeout(() => {

                if (data.data == null) {
                    alert('找不到微信登录网址');
                }

                // data.data example: "https://open.weixin.qq.com/connect/qrconnect?appid=wx2b07c913a33d290b&redirect_uri=http://api.shixun365.com/shixun_rc/login/wx/web_login&response_type=code&scope=snsapi_login#wechat_redirect"
                // this url only for wechat oAuth login
                consoleHelper.log('redirect to data: ' + data.data);
                // if (window.sessionStorage) {
                //     consoleHelper.logDebug('sessionStorage==ok');
                // } else {
                //     consoleHelper.logDebug('sessionStorage==fail');
                // }
                consoleHelper.log('axios response, errorCode ==2, is wechat, window.location.href: ' + window.location.href);
                sessionStorage.setItem('gotoBeforeUrl', window.location.href);
                consoleHelper.log('[app] gotoBeforeUrl: ' + sessionStorage.getItem('gotoBeforeUrl'));
                consoleHelper.log('[app] before redirect to: ' + data.data);

                // clear home page ad
                storageManager.removeItem('home_ad_latest_show_time');

                debugger;
                window.location.href = data.data;
            }, 1000);

            return;
        }
        // deviceHelper.isAndroid || deviceHelper.isIpad || deviceHelper.isIphone
        else
        {
            consoleHelper.log('not wechat browser');

            let url = '';

            consoleHelper.logDebug('axios response, errorCode ==2, window.location.href: ' + window.location.href);

            // url = externalApp.oldShixun.baseUrl + 'html/login/login.html?gotoBeforeUrl=' + encodeURIComponent(window.location.href);
            consoleHelper.log('mobile device, redirect to ' + url);
            sessionStorage.setItem('gotoBeforeUrl', window.location.href);

            appHelper.goToLoginPage();
        }
    }

    else if (data.errorCode === 4) {
        // disabled, no permission
    } else if (data.errorCode === 401) {
        appHelper.showHint('出错了：没有权限访问。');
    }

    return response;

}, function (error) {

    let err = error.request;
    let request = error.request;

    let result = {};
    try
    {
        result = JSON.parse(request.responseText);
    }
    catch(e)
    {
        consoleHelper.logError(e);
        consoleHelper.log('responseText: ' + request.responseText);
        return;
    }

    if (err.status >= 200 && err.status < 300)   // 预防正常回调函数出错，捕获了错误。
    {
        return;
    }

    let errorData = {
        msg : '',
    };

    try {
        errorData = JSON.parse(error.request.responseText);
    }
    catch(e)
    {
        consoleHelper.logError('JSON parse fail. source content: ' + error.request.responseText);
        return;
    }

    if (errorData.msg === 'No message available' || errorData.msg == null) {
        consoleHelper.logError(errorData.msg);
        return;
    }

    if (err.status === 400) {
        appHelper.showHint(errorData.msg);
    }
    else if (err.status === 401) {

        // window.app.removeSession();

        if (browserHelper.isWechat) {

            consoleHelper.log('errorCode: 2, current browser is wechat.');
            appHelper.showHint('转到微信登录');

            timerManager.setTimeout(() => {

                if (result.data == null) {
                    alert('找不到微信登录网址');
                }

                // data.data example: "https://open.weixin.qq.com/connect/qrconnect?appid=wx2b07c913a33d290b&redirect_uri=http://api.shixun365.com/shixun_rc/login/wx/web_login&response_type=code&scope=snsapi_login#wechat_redirect"
                // this url only for wechat oAuth login
                consoleHelper.log('redirect to data: ' + result.data);
                // if (window.sessionStorage) {
                //     consoleHelper.logDebug('sessionStorage==ok');
                // } else {
                //     consoleHelper.logDebug('sessionStorage==fail');
                // }
                consoleHelper.log('axios response, errorCode ==2, is wechat, window.location.href: ' + window.location.href);
                sessionStorage.setItem('gotoBeforeUrl', window.location.href);
                consoleHelper.log('[app] gotoBeforeUrl: ' + sessionStorage.getItem('gotoBeforeUrl'));
                consoleHelper.log('[app] before redirect to: ' + result.data);
                debugger;
                window.location.href = result.data;

            }, 1000);

            return;
        }
        // deviceHelper.isAndroid || deviceHelper.isIpad || deviceHelper.isIphone
        else
        {
            consoleHelper.log('not wechat browser');

            let url = '';

            consoleHelper.logDebug('axios response, errorCode ==2, window.location.href: ' + window.location.href);

            url = externalApp.oldShixun.baseUrl + 'html/login/login.html?gotoBeforeUrl=' + encodeURIComponent(window.location.href);
            consoleHelper.log('mobile device, redirect to ' + url);
            sessionStorage.setItem('gotoBeforeUrl', window.location.href);
            window.location.href = url;
        }

        consoleHelper.logDebug('401 ' + appConfig.messageMap.sessionTimeout);
    } else if (err.status === 403) {
        consoleHelper.log(appConfig.messageMap.permissionDeny);
        appHelper.showHint(appConfig.messageMap.permissionDeny);
    } else if (err.status === 405) {
        consoleHelper.log(appConfig.messageMap.methodNotSupport);
        appHelper.showHint(appConfig.messageMap.methodNotSupport);
    } else if (err.status === 500) {
        consoleHelper.log(appConfig.messageMap.serviceError);
        appHelper.showHint(appConfig.messageMap.serviceError);
    } else {
        consoleHelper.log(errorData.msg);
        appHelper.showHint(errorData.msg);
    }

    return Promise.reject(error);
});

// console.log('axios的基本URL请求:' + axios.defaults.baseURL);
// console.log('axios的接口环境:' + process.env.NODE_ENV);

// 全局设置 POST 请求方法的 Content-Type
axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded;charset=UTF-8';
// 全局设置 跨域请求带上认证信息
axios.defaults.withCredentials = true;
// 全局设置 请求超时
// axios.defaults.timeout = 10000
// 全局设定 axios 为 Vue 对象的方法
Vue.prototype.axios = axios // 在引用 axios 的时候加 this 指定

// Vue.prototype.apiBaseURL = axios.defaults.baseURL

export default axios
